import { StudySpaceEntityType } from '@faro/study-space-service-model';
import { studySpaceClient } from './StudySpaceClient';

export class StudySpaceService {
    get = studySpaceClient.get;
    list = studySpaceClient.list;
}

export const studySpaceEntityType: StudySpaceEntityType = 'study-space';
